import HttpRequest from "@/util/HttpRequest";
import constant from "@/constant/constant";

export default {
  /**
   * 회사 목록
   * @params {page, perPage}
   */
  async LOAD_COMPANY_LIST({ commit }, params) {
    if (!params.projectId) return;

    const option = { params };

    return new Promise((resolve, reject) => {
      HttpRequest.get("/api/v1/company", option)
        .then((response) => {
          // mutations 메소드 호출
          commit("LOAD_COMPANY_LIST", response);
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },

  /**
   * 회사 목록
   * @params {page, perPage}
   */
  async LOAD_COMPANY_TREE({ commit }, params) {
    if (!params.projectId) return;

    const option = {
      params: {
        projectId: params.projectId,
      },
    };

    const subCompanies = localStorage.getItem("sub_company");
    if (subCompanies) {
      try {
        const companies = JSON.parse(subCompanies);
        commit("LOAD_COMPANY_TREE", companies);
        return companies;
      } catch (e) {
        return undefined;
      }
    } else {
      return new Promise((resolve, reject) => {
        HttpRequest.get("/api/v1/company/tree", option)
          .then((response) => {
            localStorage.setItem("sub_company", JSON.stringify(response));

            // mutations 메소드 호출
            commit("LOAD_COMPANY_TREE", response);
            resolve(response);
          })
          .catch((err) => reject(err));
      });
    }
  },

  async LOAD_COMPANY({ commit, state }, params) {
    const companyId = params.companyId;

    if (!state.companyInfo || `${state.companyInfo.id}` !== `${companyId}`) {
      return new Promise((resolve, reject) => {
        HttpRequest.get(`/api/v1/company/${companyId}`)
          .then((response) => {
            // mutations 메소드 호출
            commit("LOAD_COMPANY", response);
            resolve(response);
          })
          .catch((err) => reject(err));
      });
    }
  },

  async LOAD_COMPANY_FIELD({ commit }, params) {
    const companyId = params.companyId;

    const option = {
      params: {
        page: params.page,
        perPage: params.perPage,
        fieldName: params.fieldName,
        fieldCode: params.fieldCode,
        projectId: params.projectId,
        fieldType: params.fieldType,
      },
    };

    return new Promise((resolve, reject) => {
      HttpRequest.get(`/api/v1/company/field/${companyId}`, option)
        .then((response) => {
          // mutations 메소드 호출
          commit("LOAD_COMPANY_FIELD", response);
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },

  async LOAD_MEMBER_LIST({ commit }, params) {
    const option = {
      params: {
        page: params.page,
        perPage: params.perPage,
        company_id: params.company_id,
      },
    };

    return new Promise((resolve, reject) => {
      HttpRequest.get("/api/v1/company/member", option)
        .then((response) => {
          // mutations 메소드 호출
          commit("LOAD_MEMBER_LIST", response);
          resolve(response);
        })
        .catch((err) => reject(err));
    });
  },
};
